import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, TypeOf, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import {useLocation} from "react-router";

import { GroupType, GroupTypePairs, toString as toStringGroupType } from "../../../types/models/GroupType.d";


import { t, msg } from "@lingui/core/macro"



export const initialFormStateFn = () => { return {
    
} }

export const useLocationFormState = (oldState) => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    

    return initialFormState
}

export const formObject = {
    
};

export const formSchema = object(formObject);

const RoleAssignmentUpdateForm = ({watch, prefix = ''})  => {
    return (
        <Container>
            
        </Container>
    )
}

export default RoleAssignmentUpdateForm;
